import React, { useContext, useState, useEffect } from 'react'
import Layout from '../../../components/templates/Layout'
import CustomTable from '../../../components/molecules/CustomTable'
import CustomSearch from '../../../components/molecules/CustomSearch'
import { useFormik } from 'formik'
import { Button } from '@mui/material'
import SettingContext from '../../../context/setting/settingContext'
import AlertContext from '../../../context/alert/alertContext'
import BidIncrementManage from './BidIncrementManage'
import { useLocation } from 'react-router-dom'
import CustomDialog from '../../../../product/components/organisms/Dialog'
import PrimaryButton from '../../../components/atoms/PrimaryButton'

const BidIncrementView = (props) => {
    const settingContext = useContext(SettingContext)
    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')
    const [isLoading, setIsLoading] = useState(true)
    const {
        bid_increments,
        getAllBidIncrements,
        deleteBidIncrement,
        responseStatus: responseStatusCommuncation,
    } = settingContext
    const { setAlert } = useContext(AlertContext)
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            id: 0,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (dataValue.action === 'deleteIncrement') {
                deleteBidIncrement({ id: dataValue.id })
            }
        },
    })

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: global.initialPageLimit ? global.initialPageLimit : 20,
            order: '',
            orderby: '',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllBidIncrements(values)
        },
    })

    useEffect(() => {
        if (bid_increments) {
            setTableBody(
                bid_increments.records.length ? bid_increments.records : []
            )
        }
        setIsLoading(false)
    }, [bid_increments])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllBidIncrements(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from ===
                    'CommunicationStaticPages' &&
                responseStatusCommuncation.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllBidIncrements(formik.values)
                setChangeStatus(false)
            }
        }
    }, [responseStatusCommuncation])

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'editIncrement') {
            toggleFullScreenPopup(true, 'edit', id)
        } else if (type === 'deleteIncrement') {
            formikSelection.values.action = type
            formikSelection.values.id = id
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'editIncrement',
            onclick: onClickEdit,
            tooltipTitle: 'Edit Bid Increment',
        })
        if (edit) {
            actionPush.push({
                buttonType: 'delete',
                clickType: 'deleteIncrement',
                onclick: onClickEdit,
                tooltipTitle: 'Delete Bid Increment',
            })
        }

        return actionPush
    }

    const tableValues = [
        {
            field: 'from_amount',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: global.biddingRound ? 'From Range' : 'From Amount',
        },
        {
            field: 'to_amount',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: global.biddingRound ? 'To Range' : 'To Amount',
        },
        {
            field: 'increment',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Bid Increment',
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const searchInfo = [
        {
            label: 'Page',
            placeholder: 'Enter Page',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
    ]

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            {' '}
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="bidIncrement_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Bid Increment Range
                    </Button>
                </div>
                {isLoading ? (
                    <div>Loading..</div>
                ) : (
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={bid_increments}
                        changeTableFunction={getAllBidIncrements}
                        columnStorageVariable={'table_bid_increment_view'}
                    />
                )}
            </div>
            <BidIncrementManage
                data={manage}
                function={toggleFullScreenPopup}
            />
            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'deleteIncrement'
                        ? 'Are you sure you want to delete'
                        : 'Are you sure you want to enable'}
                </h5>
                <div className="actionWrapper">
                    <Button
                        id="config_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="configView_cancel"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default BidIncrementView
